export default {
  appBar: {},
  articles: {},
  auth: {},
  cacheIndex: {},
  counterStrikeGlobalOffensive: {
    selectedWeapon: 'ak47',
  },
  currentGamer: {},
  currentGamerProfile: {},
  currentGamerPurchaseProfile: {},
  dialog: {
    open: false,
  },
  flickPowerRankingCount: 0,
  flickPowerRankings: {},
  followThroughPowerRankingCount: 0,
  followThroughPowerRankings: {},
  fortnitePowerRankingCount: 0,
  fortnitePowerRankings: {},
  gameInterface: {},
  gamers: {},
  gameSounds: {
    gunSound: 'default',
  },
  mobilePowerRankingCount: 0,
  mobilePowerRankings: {},
  overallStatistics: {},
  otherGamer: {},
  otherGamerProfile: {},
  powerRankingCount: 0,
  powerRankings: {},
  purchases: {
    donationAmount: 1,
  },
  snackbar: {},
  speedPowerRankingCount: 0,
  speedPowerRankings: {},
  trackingPowerRankingCount: 0,
  trackingPowerRankings: {},
  userInterface: {
    activeGameTab: 0,
    activeTab: 1,
  },
  weeklyStatistics: {},
}



// WEBPACK FOOTER //
// ./src/app/store/initialState.js